import React from 'react';

import styledComponents from 'styled-components';

import { SELECTABLE_HIGHLIGHT_COLOR } from './styleConstants';

const Header = styledComponents.div`
  display: flex;
  flex-direction: row;
  flex-justify: start
  `;

const Inner = styledComponents.div`
  background-color: ${({ dataHidden }) => (dataHidden ? 'transparent' : SELECTABLE_HIGHLIGHT_COLOR)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  >div, >button {
  margin: 4px 8px;
  };
  opacity: ${({ dataHidden }) => (dataHidden ? '0.5' : '1')}
`;
const Remainder = styledComponents.div`
  flex-grow: 100;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
`;

export default ({ children, dataHidden, popLast }) => {
  let remainder = '';
  let content = children;
  if (popLast) {
    content = React.Children.toArray(children);
    remainder = content.pop();
  }
  return (
    <Header>
      <Inner dataHidden={dataHidden}>
        {content}
      </Inner>
      <Remainder>{remainder}</Remainder>
    </Header>
  );
};
